module.exports = __webpack_public_path__ + "static/img/feiliaozhan.103cb52e.png";